<header-row
   [userName]="'Victoria Brown'"
   [userRole]="'REGIONAL MANAGER'"></header-row>

<div
   *ngIf="!isLoading"
   class="page-layout">
   <h2 class="main-title">Tasks & Updates</h2>

   <div class="stats-grid">
      <div
         class="stat-card"
         *ngFor="let stat of taskStats">
         <div
            class="icon-circle"
            [ngClass]="stat.colorClass">
            <span class="material-icons">{{ stat.icon }}</span>
         </div>
         <div class="stat-info">
            <div class="count">{{ stat.count }}</div>
            <div class="label">{{ stat.label }}</div>
         </div>
      </div>
   </div>

   <div class="content-box">
      <div class="box-header">
         <div class="sideheader">
            <h3>Task Overview</h3>
         </div>

          <div class="filters">
             <div class="select-wrap">
                <select
                   [ngModel]="selectedQuarter"
                   (ngModelChange)="onQuarterChange($event)"
                   [disabled]="!quarterList?.length"
                   aria-label="Filter by Quarter"
                   title="Filter by Quarter">
                   <option *ngFor="let q of quarterList" [value]="q.quarterName">
                      {{ q.quarterName }}
                   </option>
                </select>
                <span class="material-icons arrow">expand_more</span>
             </div>
             <div class="select-wrap">
                <p-multiSelect
                   [options]="dueDateOptions"
                   optionLabel="label"
                   optionValue="value"
                   [(ngModel)]="duedate"
                   placeholder="Filter by Due Date"
                   (onChange)="applyFilters()"
                   [showClear]="true"
                   [filter]="true"
                   [maxSelectedLabels]="1"
                   selectedItemsLabel="{0} dates selected"
                   appendTo="body"></p-multiSelect>
             </div>
            <div class="select-wrap">
               <p-multiSelect
                  [options]="uniqueHospitals"
                  [(ngModel)]="selectedHospitals"
                  placeholder="Filter by Hospital"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  [maxSelectedLabels]="1"
                  selectedItemsLabel="{0} hospitals selected"
                  appendTo="body"></p-multiSelect>
            </div>
             <div class="select-wrap">
                <p-multiSelect
                   [options]="uniqueStatuses"
                   [(ngModel)]="selectedStatuses"
                   placeholder="Filter by Status"
                   (onChange)="applyFilters()"
                   [showClear]="true"
                   [filter]="true"
                   [maxSelectedLabels]="1"
                   selectedItemsLabel="{0} statuses selected"
                   appendTo="body"></p-multiSelect>
             </div>
            <button
               class="reset-btn"
               type="button"
               [class.active]="priorityPracticeOnly"
               (click)="togglePriorityPracticeFilter()">
               <span class="material-icons">{{ priorityPracticeOnly ? "star" : "star_border" }}</span>
               Priority Practice
            </button>

            <button
               class="reset-btn"
               (click)="resetFilters()">
               <span class="material-icons">refresh</span>
               Reset Filters
            </button>
            <div class="toggle-group">
               <button
                  class="toggle-btn"
                  [class.active]="assignedToMeFilter === null"
                  (click)="setAssignedFilter(null)">
                  All
               </button>
               <button
                  class="toggle-btn"
                  [class.active]="assignedToMeFilter === true"
                  (click)="setAssignedFilter(true)">
                  Assigned to Me
               </button>
               <button
                  class="toggle-btn"
                  [class.active]="assignedToMeFilter === false"
                  (click)="setAssignedFilter(false)">
                  Assigned to Others
               </button>
            </div>

            <!--
            <div class="select-wrap">
               <select [(ngModel)]="selectedGoal" (ngModelChange)="applyFilters()">
                  <option value="">Filter by Goal</option>
                  <option *ngFor="let g of uniqueGoals" [value]="g">
                     {{ g }}
                  </option>
               </select>
               <span class="material-icons arrow">expand_more</span>
            </div>

            <div>
               <button class="reset-btn" (click)="resetFilters()">
                  <span class="material-icons">refresh</span>
                  Reset Filters
               </button> -->

            <button
               class="submit-btn"
               (click)="createNewtask()">
               <span class="material-icons">add</span>
               Create New Task
            </button>
         </div>
      </div>

      <ng-container *ngIf="dataSource?.data?.length > 0; else noTasks">
         <table
            mat-table
            [dataSource]="dataSource"
            class="mat-elevation-z1 data-table"
            matSort>
            <!-- Assigned Type Column -->
            <ng-container matColumnDef="assignedId">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 8%">
                  Assigned Type
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="type-badge">
                     <span
                        class="material-icons"
                        matTooltip="Assign To Me"
                        *ngIf="row.assignedToId === 0">
                        person
                     </span>
                     <span
                        class="material-icons"
                        matTooltip="Assign To Others"
                        *ngIf="row.assignedToId > 0">
                        groups
                     </span>
                  </div>
               </td>
            </ng-container>

            <ng-container matColumnDef="assignedName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 15%">
                  Assigned To
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="hospital-col">
                  {{ row.assignedTo }}
               </td>
            </ng-container>

            <!-- Days Until Due Column -->
            <ng-container matColumnDef="daysUntilDue">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 10%">
                  Days Until Due
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="center">
                  <span
                     class="days-until-due"
                     [class.past-due]="isPastDue(row.dueDate)">
                     {{ getDaysUntilDue(row) ?? '-'}}
                  </span>
               </td>
            </ng-container>

            <!-- Hospital Column -->
            <ng-container matColumnDef="hospitalName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 15%">
                  Hospital
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="hospital-col">
                  {{ row.hospitalName || "No Hospital Assigned" }}
               </td>
            </ng-container>

            <!-- Task Column -->
            <ng-container matColumnDef="task">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 20%">
                  Task
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="task-desc"
                  (click)="openViewTask(row.taskId)">
                  {{ row.task }}
               </td>
            </ng-container>

            <!-- Goal Column -->
            <ng-container matColumnDef="goalName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 15%">
                  Affiliated Goal
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  {{ row.goalName }}
               </td>
            </ng-container>

            <!-- Recurrence Column -->
            <ng-container matColumnDef="recurrence">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 10%">
                  Schedule
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="center">
                  <button class="view-schedule-btn-table"
                          (click)="$event.stopPropagation(); openRecurrencePreview(row)">
                    <mat-icon>event_repeat</mat-icon>
                    View
                  </button>
               </td>
            </ng-container>

            <!-- Created By Column -->
            <ng-container matColumnDef="createdBy">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 12%">
                  Created By
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="center">
                  {{ row.createdByName }}
               </td>
            </ng-container>

            <!-- Category Column -->
            <ng-container matColumnDef="categoryName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 12%">
                  Category
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  class="category-col">
                  {{ row.categoryName }}
               </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="statusName">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  style="width: 10%">
                  Status
               </th>
               <td
                  mat-cell
                  *matCellDef="let row">
                  <span
                     class="status-badge"
                     [ngClass]="getStatusClass(row.statusName)">
                     {{ row.statusName }}
                  </span>
               </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
               <th
                  mat-header-cell
                  *matHeaderCellDef
                  style="width: 5%; text-align: center">
                  Actions
               </th>
               <td
                  mat-cell
                  *matCellDef="let row"
                  style="text-align: center">
                  <ng-container *ngIf="isAdmin">
                     <button
                        mat-icon-button
                        [matMenuTriggerFor]="menu"
                        class="action-btn">
                        <mat-icon>more_vert</mat-icon>
                     </button>
                     <mat-menu
                        #menu="matMenu"
                        class="task-action-menu">
                        <button
                           mat-menu-item
                           (click)="editTask(row)">
                           <mat-icon>edit</mat-icon>
                           <span>Edit Task</span>
                        </button>
                        <button
                           mat-menu-item
                           (click)="deleteTask(row)"
                           class="delete-action">
                           <mat-icon>delete</mat-icon>
                           <span>Delete Task</span>
                        </button>
                     </mat-menu>
                  </ng-container>
               </td>
            </ng-container>

            <tr
               mat-header-row
               *matHeaderRowDef="displayedColumns"></tr>
            <tr
               mat-row
               *matRowDef="let row; columns: displayedColumns"
               [attr.id]="'search-row-task-' + row.taskId"></tr>
         </table>

         <mat-paginator
            [pageSize]="50"
            [pageSizeOptions]="[10, 20, 50, 100, 500, 1000]"
            showFirstLastButtons
            aria-label="Select page of tasks"></mat-paginator>
      </ng-container>
      <ng-template #noTasks>
         <div
            class="empty-state"
            style="text-align: center; padding: 40px 20px; color: #4f4f4f">
            <div
               class="empty-icon"
               style="
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  width: 72px;
                  height: 72px;
                  border-radius: 50%;
                  background: #f1f5f9;
                  margin-bottom: 16px;
               ">
               <span
                  class="material-icons"
                  style="color: #00ba9d; font-size: 36px">
                  assignment
               </span>
            </div>
            <h4 style="margin: 0 0 8px; font-weight: 600">No tasks found</h4>
            <p style="margin: 0 0 16px">Try adjusting filters or create a new task.</p>
         </div>
      </ng-template>
   </div>
</div>

<div
   *ngIf="isLoading"
   style="
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.95);
      z-index: 9999;
   ">
   <div style="text-align: center">
      <img
         src="/assets/catSpinner.gif"
         style="width: 130px; margin-bottom: 20px" />
      <div style="color: #363636; font-size: 24px">Please wait...</div>
   </div>
</div>
